function wlKey(brand) {
  return `wishlist_${brand}`;
}    

function wlLoad(brand) {
  const list = JSON.parse(localStorage.getItem(wlKey(brand)) || '[]');
  return [...new Set(list.map(id => id.toString()).filter(Boolean))];
}

function wlSave(brand, list) {
  const cleanList = [...new Set(list.map(id => id.toString()).filter(Boolean))];
  localStorage.setItem(wlKey(brand), JSON.stringify(cleanList));
}

function wlUpdateCounter(brand) {
  const el = document.querySelector(`.wishlist-counter[data-brand="${brand}"]`);
  if (!el) return;

  const qty = wlLoad(brand).length;
  el.textContent = qty;
  el.hidden = qty === 0;
}

document.addEventListener('click', e => {
  const btn = e.target.closest('[data-brand][data-product-id]');
  if (!btn) console.log("no se encontro nadita");
  if (!btn) return;

  const brand = btn.dataset.brand;
  const id = btn.dataset.productId?.toString();
  if (!brand || !id) return;

  const list = wlLoad(brand);
  const index = list.indexOf(id);

  if (index === -1) {
    list.push(id);
  } else {
    list.splice(index, 1);
  }

  wlSave(brand, list);
  wlUpdateCounter(brand);
});

const currentBrand = localStorage.getItem('CurrentBrand');
if (currentBrand) {
  wlUpdateCounter(currentBrand);
}
